import { COMM_CHANNELS } from "@/lib/contactChannels";

// value: array of { channel, value }. onChange receives the updated array.
export default function CommChannelsPicker({ value = [], onChange }) {
  const byChannel = Object.fromEntries((value || []).map((c) => [c.channel, c.value]));

  const toggle = (ch, checked) => {
    let next = (value || []).filter((c) => c.channel !== ch);
    if (checked) next = [...next, { channel: ch, value: byChannel[ch] || "" }];
    onChange(next);
  };
  const setVal = (ch, v) => {
    const next = (value || []).map((c) => (c.channel === ch ? { ...c, value: v } : c));
    onChange(next);
  };

  return (
    <div className="space-y-2" data-testid="comm-channels">
      {COMM_CHANNELS.map((opt) => {
        const active = opt.value in byChannel;
        return (
          <div key={opt.value} className="flex items-center gap-3">
            <label className="flex items-center gap-2 w-32 shrink-0 cursor-pointer text-sm">
              <input
                type="checkbox"
                checked={active}
                onChange={(e) => toggle(opt.value, e.target.checked)}
                className="w-4 h-4 accent-orange-600"
                data-testid={`comm-check-${opt.value}`}
              />
              {opt.label}
            </label>
            <input
              type="text"
              disabled={!active}
              value={byChannel[opt.value] || ""}
              onChange={(e) => setVal(opt.value, e.target.value)}
              placeholder="Nr. telefon / utilizator"
              className="flex-1 border border-slate-300 px-3 py-1.5 text-sm focus:border-orange-500 outline-none disabled:bg-slate-100"
              data-testid={`comm-value-${opt.value}`}
            />
          </div>
        );
      })}
    </div>
  );
}
